import React, { useEffect, useState } from 'react';

const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const scrollContainer = document.getElementById('scrollable-content');

    const handleScroll = () => {
      const scrollTop = scrollContainer.scrollTop;
      setVisible(scrollTop > 300);
    };

    scrollContainer.addEventListener('scroll', handleScroll);
    return () => scrollContainer.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    const scrollContainer = document.getElementById('scrollable-content');
    scrollContainer.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      onClick={scrollToTop}
      style={{
        position: 'absolute',
        bottom: '20px',
        right: '20px',
        padding: '10px 15px',
        fontSize: '20px',
        border: 'none',
        borderRadius: '50%',
        backgroundColor: '#333',
        color: 'white',
        cursor: 'pointer',
        boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
        display: visible ? 'block' : 'none',
        zIndex: 1000
      }}
    >
      ↑
    </button>
  );
};

export default ScrollToTopButton;
